import React from "react";
import {StyledMyButton} from "./MyButton.styles";

export const MyButton = ({children, ...props}) => (
    <StyledMyButton {...props}>
        {children}
    </StyledMyButton>
)